export const taskWorkerAmountInvalidFields = ['rangeFrom', 'rangeTo', 'maxWorkUnitAmount']
